/**
 * from back end
 */
export const BAD_TOKEN = 'BAD_TOKEN'

export const TOKEN_TIME_OUT_CODE = '10011'

export const TOKEN_TIME_OUT = 'TOKEN_TIME_OUT'

export const NAME_PWD_ERROR = 'BAD_USERNAME_OR_PWD'

export enum ErrorCode {
  OK = 0,
  /** Canceled - 0 - 17 是公共的错误码 */
  Canceled = 1,
  /** Unknown - 未知错误 */
  Unknown = 2,
  /** InvalidArgument - 无效的参数 */
  InvalidArgument = 3,
  /** DeadlineExceeded - 请求超时 */
  DeadlineExceeded = 4,
  /** NotFound - 请求的对象不存在 */
  NotFound = 5,
  /** AlreadyExists - 创建的对象已经存在 */
  AlreadyExists = 6,
  /** PermissionDenied - 没有权限 */
  PermissionDenied = 7,
  /** ResourceExhausted - 资源紧张 */
  ResourceExhausted = 8,
  /** FailedPrecondition - 请求拒绝，前置量不对。 */
  FailedPrecondition = 9,
  /** Aborted - 服务器异常，操作终止，可重试 */
  Aborted = 10,
  /** OutOfRange - 越界 */
  OutOfRange = 11,
  /** Unimplemented - 接口没有实现 */
  Unimplemented = 12,
  /** Internal - 服务器错误 */
  Internal = 13,
  /** Unavailable - 服务器未知错误 */
  Unavailable = 14,
  /** DataLoss - 数据丢失，一般不会存在 */
  DataLoss = 15,
  /** Unauthenticated - 需求授权后，请求 */
  Unauthenticated = 16,
  /** TooManyRequests -  */
  TooManyRequests = 100,
  /** NotSupport - 请求不支持 */
  NotSupport = 101,
  /** MissingConfig - 缺少配置，请联系管理员 */
  MissingConfig = 102,
  /** ConfigError - 配置错误，请联系管理员 */
  ConfigError = 103,
  /** AccountNotFound - 用户错误码 */
  AccountNotFound = 10001,
  /** PasswordError - 密码错误 */
  PasswordError = 10002,
  /** AuthRequestError - 登陆时，第三方请求授权失败，请检查参数 */
  AuthRequestError = 10003,
  /** NotLogin - 没有登陆 */
  NotLogin = 10004,
  /** NotSupportTmpl - 不支持的模版 */
  NotSupportTmpl = 10005,
  /** ChannelConfigError - 渠道配置异常，这种场景下，需要弹窗提示 */
  ChannelConfigError = 10006,
  /** InsufficientFunds - 钱包余额不足 */
  InsufficientFunds = 10007,
  /** NotSupportRegisterType - 不支持的注册类型 */
  NotSupportRegisterType = 10008,
  /** VerifyCodeExpired - 验证码过期 */
  VerifyCodeExpired = 10009,
  /** VerifyCodeNotMatch - 验证码不匹配 */
  VerifyCodeNotMatch = 10010,
  /** TokenExpired - token  过期 */
  TokenExpired = 10011,
  /** HasUnsettledorders - wallet/order */
  HasUnsettledorders = 11001,
  /** AmountNotSame - 金额不一致, 重新流程 */
  AmountNotSame = 11002,
  /** AccountBand - 账号被禁用 */
  AccountBand = 10013,
  /** GroupBand - 集团被禁用 */
  GroupBand = 10014,
  /** GroupMemberBand - 集团被禁用 */
  GroupMemberBand = 10015,
  /** GroupMemberNotFound - 集团成员不存在 */
  GroupMemberNotFound = 10016,
  /** PaymentOrderStatusError - 订单支付状态异常，请重新下单 */
  PaymentOrderStatusError = 11007,
  /** NotSupportPostpaymentMode - 不支持的后付费支付模式 */
  NotSupportPostpaymentMode = 11008,
  /** AmountIsNil - 金额是空, 请求选择充电金额 */
  AmountIsNil = 11009,
  /** EvseOffline - 设备错误码 */
  EvseOffline = 20001,
  /** EvseNotOperation - 设备未运营 */
  EvseNotOperation = 20002,
  /** EvseTimeout - 设备响应超时 */
  EvseTimeout = 20003,
  /** EvseConfAbnormalState - 设备响应的状态异常 */
  EvseConfAbnormalState = 20004,
  /** EvseBusy - 设备繁忙 */
  EvseBusy = 20005,
  /** EvseOccupy - 设备占用 */
  EvseOccupy = 20006,
  /** NotExpectedConnectorState - 不是预期的充电状态，不能发起充电 */
  NotExpectedConnectorState = 20007,
  /** EvseStartParamError - 启动充电的信息不充足 */
  EvseStartParamError = 20008,
  /** MissingEvseInfo - 缺少设备信息 */
  MissingEvseInfo = 20009,
  /** NotHaveEvse - 不拥有设备 */
  NotHaveEvse = 20010,
  /** UnsupportChangeCNum - 不支持修改枪头数量 */
  UnsupportChangeCNum = 20011,
  /** UnsupportChangeSN - 不支持修改SN */
  UnsupportChangeSN = 20012,
  /** OperatorNotMatch - 运营商不匹配 */
  OperatorNotMatch = 20013,
  /** StationEvseType - 存在设备类型不一致的设备 */
  StationEvseType = 20014,
  /** UnsupportFunc - 设备不支持此功能 */
  UnsupportFunc = 20015,
  /** EvseRejected - 设备拒绝 */
  EvseRejected = 20016,
  /** EvseUnknown - 设备未知状态 */
  EvseUnknown = 20017,
  /** NotFoundAvailableEvse - 没有可用的设备 */
  NotFoundAvailableEvse = 20018,
  /** OnlineCardNotSupport - card */
  OnlineCardNotSupport = 21001,
  /** LocalCardNotSupport - 离线线卡不支持 */
  LocalCardNotSupport = 21002,
  /** OrderPreStateIllegal - 订单 */
  OrderPreStateIllegal = 30001,
  /**
     OrderPriceTariffsTagConfigError - 订单计费尖峰平谷配置错误（定价不一致）
   */
  OrderPriceTariffsTagConfigError = 30002,
  /** OrderPriceTariffsNotSupport - 计费模版不支持 */
  OrderPriceTariffsNotSupport = 30003,
  /** ActivityClose - 已结束 */
  ActivityClose = 31002,
  /** ActivityBanned - 活动已经禁用 */
  ActivityBanned = 31003,
  /** CouponUSED - 优惠券已经使用 */
  CouponUSED = 31004,
  /** CouponExpired - 优惠券过期 */
  CouponExpired = 31005,
  /** ExistsSameTypeActivity - 存在相同类型的活动 */
  ExistsSameTypeActivity = 31006,
  UNRECOGNIZED = -1,
}

export const parseError = (rsp: any): string => {
  switch (rsp?.code) {
    case 1:
      return 'Error.errCanceled'
    case 2:
      return 'Error.errUnknown'
    case 3:
      return 'Error.errInvalidArgument'
    case 4:
      return 'Error.errDeadlineExceeded'
    case 5:
      return 'Error.errNotFound'
    case 6:
      return 'Error.errAlreadyExists'
    case 7:
      return 'Error.errPermissionDenied'
    case 8:
      return 'Error.errResourceExhausted'
    case 9:
      return 'Error.errFailedPrecondition'
    case 10:
      return 'Error.errAborted'
    case 11:
      return 'Error.errOutOfRange'
    case 12:
      return 'Error.errUnimplemented'
    case 13:
      return 'Error.errInternal'
    case 14:
      return 'Error.errUnavailable'
    case 15:
      return 'Error.errDataLoss'
    case 16:
      return 'Error.errUnauthenticated'
    case 100:
      return 'Error.errTooManyRequests'
    case 101:
      return 'Error.errNotSupport'
    case ErrorCode.MissingConfig:
      return 'Error.errMissingConfig'
    case ErrorCode.ConfigError:
      return 'Error.errConfigError'
    case 110:
      return 'Error.errNoData'
    case 10001:
      return 'Error.errAccountNotFound'
    case 10002:
      return 'Error.errPasswordError'
    case 10003:
      return 'Error.errAuthRequestError'
    case 10004:
      return 'Error.errNotLogin'
    case 10005:
      return 'Error.errNotSupportTmpl'
    case 10006:
      return 'Error.errChannelConfigError'
    case 10007:
      return 'Error.errInsufficientFunds'
    case 10008:
      return 'Error.errNotSupportRegisterType'
    case 10009:
      return 'Error.errVerifyCodeExpired'
    case 10010:
      return 'Error.errVerifyCodeNotMatch'
    case 10011:
      return 'Error.errAccountBand'
    case 10012:
      return 'Error.errGroupBand'
    case 10013:
      return 'Error.errGroupMemberBand'
    case 10014:
      return 'Error.errGroupMemberNotFound'
    case 11001:
      return 'Error.errHasUnsettledorders'
    case 11002:
      return 'Error.errAmountNotSame'
    case 11007:
      return 'Error.errPaymentOrderStatusError'
    case 11008:
      return 'Error.errNotSupportPostpaymentMode'
    case 11009:
      return 'Error.errAmountIsNil'
    case 20001:
      return 'Error.errEvseOffline'
    case 20002:
      return 'Error.errEvseNotOperation'
    case 20003:
      return 'Error.errEvseTimeout'
    case 20004:
      return 'Error.errEvseConfAbnormalState'
    case 20005:
      return 'Error.errEvseBusy'
    case 20006:
      return 'Error.errEvseOccupy'
    case 20007:
      return 'Error.errNotExpectedConnectorState'
    case 20008:
      return 'Error.errEvseStartParamError'
    case 20009:
      return 'Error.errMissingEvseInfo'
    case 20010:
      return 'Error.errNotHaveEvse'
    case 20011:
      return 'Error.errUnsupportChangeCNum'
    case 20012:
      return 'Error.errUnsupportChangeSN'
    case 21001:
      return 'Error.errOnlineCardNotSupport'
    case 21002:
      return 'Error.errLocalCardNotSupport'
      /**  - 设备响应超时 */
    case ErrorCode.EvseTimeout:  // = 20003,
      return 'Error.errEvseTimeout'
    /**  - 设备响应的状态异常 */
    case ErrorCode.EvseConfAbnormalState:  // = 20004,
      return 'Error.errEvseConfAbnormalState'
    /**  - 设备繁忙 */
    case ErrorCode.EvseBusy:  // = 20005,
      return 'Error.errEvseBusy'
    /**  - 设备占用 */
    case ErrorCode.EvseOccupy:  // = 20006,
      return 'Error.errEvseOccupy'
    /**  - 不是预期的充电状态，不能发起充电 */
    case ErrorCode.NotExpectedConnectorState:  // = 20007,
      return 'Error.errNotExpectedConnectorState'
    /**  - 启动充电的信息不充足 */
    case ErrorCode.EvseStartParamError:  // = 20008,
      return 'Error.errEvseStartParamError'
    /**  - 缺少设备信息 */
    case ErrorCode.MissingEvseInfo:  // = 20009,
      return 'Error.errMissingEvseInfo'
    /**  - 不拥有设备 */
    case ErrorCode.NotHaveEvse:  // = 20010,
      return 'Error.errNotHaveEvse'
    /**  - 不支持修改枪头数量 */
    case ErrorCode.UnsupportChangeCNum:  // = 20011,
      return 'Error.errUnsupportChangeCNum'
    /**  - 不支持修改SN */
    case ErrorCode.UnsupportChangeSN:  // = 20012,
      return 'Error.errUnsupportChangeSN'
    /**  - 运营商不匹配 */
    case ErrorCode.OperatorNotMatch:  // = 20013,
      return 'Error.errOperatorNotMatch'
    /**  - 存在设备类型不一致的设备 */
    case ErrorCode.StationEvseType:  // = 20014,
      return 'Error.errStationEvseType'
    /**  - 设备不支持此功能 */
    case ErrorCode.UnsupportFunc:  // = 20015,
      return 'Error.errUnsupportFunc'
    /**  - 设备拒绝 */
    case ErrorCode.EvseRejected:  // = 20016,
      return 'Error.errEvseRejected'
    /**  - 设备未知状态 */
    case ErrorCode.EvseUnknown:  // = 20017,
      return 'Error.errEvseUnknown'
    /**  - 没有可用的设备 */
    case ErrorCode.NotFoundAvailableEvse:  // = 20018,
      return 'Error.errNotFoundAvailableEvse'
    case 30001:
      return 'Error.errOrderPreStateIllegal'
    case ErrorCode.OrderPriceTariffsTagConfigError:
      return 'Error.errOrderPriceTariffsTagConfig'
  }
  return 'Error.errUnknown'
}
